<template>

       <div
               :class="isActive"
               class="switcher shade">
           <div  v-click-outside="hide"></div>

           <button class="switcher__button"

                   :class="isActive"
                   @click="toggle">
               <svg class="switcher__icon"  width="36" height="28" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M8.71 0L.00006104 3.87118 0 24.4629l8.70993-3.8715V0H8.71zm1.09602.0881827V20.6256L18.515 25.464V4.92663L9.80602.0881827zM28.321 1.08931L19.6111 4.9608v20.5914l8.7099-3.8706V1.08931z"/>
                   <circle cx="29.351" cy="21.5302" r="4.94766" fill="#fff"/><circle cx="29.3514" cy="21.5301" r="6.47002" fill="#fff"/>
                   <path d="M30.5837 22.9865l.1491-.0745.0745-.1491 2.0184-4.0367.3604-.7208c.8529.9275 1.3737 2.1653 1.3737 3.5247 0 2.8767-2.3322 5.2089-5.2089 5.2089-1.3594 0-2.5971-.5208-3.5247-1.3737l.7208-.3604 4.0367-2.0184zm2.292-5.2915l-.7208.3604-4.0368 2.0183-.149.0746-.0746.149-2.0183 4.0368-.3604.7208c-.8529-.9276-1.3737-2.1654-1.3737-3.5248 0-2.8768 2.3321-5.2088 5.2088-5.2088 1.3594 0 2.5972.5207 3.5248 1.3737z"/>
               </svg>
           </button>


               <div class="switcher__inner" >
                   <ul class="switcher__list">
                       <li class="switcher__list-item"
                           v-for="item in mapItems" :key="item.id"
                           @click="switchThemeHandler(item)"
                           :class="selected === item.id ? 'is-selected' : ''"
                       >
                           <img class="switcher__list-pic" :src="require(`@/assets/img/themes/${item.type}.png`)" alt="">
                           <div class="switcher__list-text">
                               {{item.type}}
                           </div>
                       </li>
                   </ul>

               </div>
       </div>
</template>


<script>
    import toggle from '@/mixins/toggle.vue'
    import {addImages} from '@/helpers/map'
    import {
        MAP_SERVICES_SOURCE_ID,
        MAP_ADDRESS_SOURCE_ID,
        MAP_DRAWING_ZONE,
        MARKER_STATUS_2,
        MARKER_STATUS_3,
        MARKER_STATUS_4,
        MARKER_STATUS_5,
        MARKER_STATUS_7,
        MARKER_SAME_POSITION,
        mapIcons
    } from '@/data/variables'
    export default {
        mixins: [toggle],
        props: ['map'],
        mounted() {
            this.popupItem = this.$el
        },
        methods: {
          removeClientAddressImages() {
              const imagesId = [MARKER_STATUS_2,MARKER_STATUS_3,MARKER_STATUS_4,MARKER_STATUS_5,MARKER_STATUS_7, MARKER_SAME_POSITION];
              imagesId.forEach((img => {
                  if(this.map.hasImage(img)) {
                      this.map.removeImage(img)
                  }
              }))
          },
        addClientAddressImages() {
            addImages(this.map, mapIcons)
        },
          switchThemeHandler(item) {
              if(this.selected === item.id) return;
              const map = this.map;
              const {id, style} = item;
              map.setStyle(style);
              this.removeClientAddressImages();
              this.selected = id;
              const savedLayers = [];
              const savedSources = {};
              const layerGroups = [MAP_SERVICES_SOURCE_ID, MAP_ADDRESS_SOURCE_ID, "DRAW_CIRCLE", MAP_DRAWING_ZONE];
              map.getStyle().layers.forEach((layer) => {
                  const layerSource = layer.source;
                  if(layerGroups.includes(layerSource)) {
                      savedSources[layerSource] = map.getSource(layerSource).serialize();
                      savedLayers.push(layer);
                  }
              });

              setTimeout(() => {
                  for ( let [id, source] of Object.entries(savedSources)) {
                      if (map.getSource(id)) map.removeSource(id);
                      map.addSource(id, source);
                  }
                  this.addClientAddressImages();
                  savedLayers.forEach((l => map.addLayer(l)));
              }, 1000);

          }
        },
        data() {
            return {
                selected: 3,
                mapItems: [
                    {
                        id: 1,
                        type: 'Map',
                        style: 'mapbox://styles/noterfull7/ck4jxh21x125v1clwj3kvtvf8'
                    },
                    {
                        id: 2,
                        type: 'Satellite',
                        style: 'mapbox://styles/mapbox/satellite-v9'
                    },
                    {
                        id: 3,
                        type: 'Road',
                        style: 'mapbox://styles/mapbox/streets-v11'
                    },
                    {
                        id: 4,
                        type: 'Outdoors',
                        style: 'mapbox://styles/mapbox/outdoors-v11'
                    },
                ]
            }
        }

    }
</script>
<style lang="sass" scoped>
    .switcher
        position: fixed
        bottom: 19px
        left: 33px
        z-index: 111
        display: flex
        align-items: center
        justify-content: flex-start
        height: 60px
        width: 60px
        +tr(width .3s ease)
        &.is-active
            width: 310px
            .switcher__inner
                opacity: 1
                visibility: visible
        &__button
            +flex-center
            width: 60px
            height: 100%
            outline: 0
            cursor: pointer
            flex-shrink: 0
            &.is-active,
            &:hover
                svg
                    fill: #2C64FF
        &__icon
            fill: #01254E
            +tr(fill .3s ease)
        &__inner
            border-left: 1px solid #D7DDE1
            width: 100%
            padding: 6px 16px
            +tr(all .3s ease)
            opacity: 0
            visibility: hidden
        &__list
            display: flex
            align-items: flex-start
            margin-left: -8px
            &-item
                width: 48px
                height: 48px
                position: relative
                margin-left: 8px
                +tr(transform .3s ease)
                cursor: pointer
                &:before,
                &:after
                    content: ''
                    z-index: 1
                    display: block
                    position: absolute
                    width: 100%
                    left: 0
                    border-radius: 4px
                &:before
                    top: 0
                    height: 100%
                    border: 3px solid transparent
                    +tr(border-color .2s ease-in)
                &:after
                    background: linear-gradient(1.94deg, rgba(1, 37, 78, 0.46) 1.79%, rgba(1, 37, 78, 0.35) 44.77%, rgba(1, 37, 78, 0) 94.51%)
                    height: 25px
                    bottom: 0
                &:hover
                    transform: translate(0, -3px)
                &:hover,
                &.is-selected
                    &:before
                        border-color: #2C64FF
            &-pic
                position: absolute
                top: 0
                left: 0
                width: 100%
                height: 100%
                border-radius: 4px
                box-shadow: 0px 2px 4px rgba(1, 37, 78, 0.2)
            &-text
                position: absolute
                padding: 4px
                z-index: 2
                bottom: 0
                +medium
                font-weight: 500
                color: $color--white
                font-size: 8px
                letter-spacing: 0.0573529px
</style>